import "core-js/modules/es.promise.js";
import { prepareApi } from '../../utils';
import { shareChannelMap, commitShare } from './commit-share';
prepareApi(['bcz_system']);
/**
 * 页面内分享 - 分享图文消息
 * @param shareOption 分享选项
 * @param onShareSend 分享触发后执行的回调函数
 */

export function channelShare(shareOption, onShareSend) {
  return new Promise(function (resolve, reject) {
    window.bcz_system.onShareSend = function (channelInfo) {
      var channel;

      try {
        channel = channelInfo === null || channelInfo === void 0 ? void 0 : channelInfo['channel'];
      } catch (err) {// do nothing
      }

      onShareSend === null || onShareSend === void 0 ? void 0 : onShareSend(channel || 'unknown');
    };

    window.bcz_system.onShare = function (resultStr, channelInfo) {
      try {
        var result = JSON.parse(resultStr);

        if (result['errCode'] === 0) {
          var channel = void 0; // iOS 和 Android 回调注入的参数不一致，需要兼容处理

          {
            try {
              // for iOS
              channel = JSON.parse(channelInfo).channel;
            } catch (err) {
              // for Android
              channel = channelInfo;
            }
          }
          resolve({
            channel: shareChannelMap[channel] || 'unknown'
          });
        } else {
          reject(new Error(resultStr));
        }
      } catch (err) {
        reject(err);
      }
    };

    commitShare(shareOption);
  });
}